/* app/js/src/components/common/dateinput/dateinput.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
div:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
div::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div.ng-invalid.ng-dirty,
div.ng-invalid.ng-touched {
  border-color: #ef5350;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.9em;
  line-height: 2em;
  height: auto;
  padding-right: 7px;
}
div span {
  display: block;
  color: #232f3a;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
div i {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;
}
div i svg {
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div i svg path {
  fill: #879baf;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div i:active svg {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
}
div i:active svg path {
  fill: #232f3a;
}
/*# sourceMappingURL=dateinput.component.css.map */
